import {GET, POST} from '../constants/API_CONSTANTS';
import {
  API_BAD_CREATE_ORDER,
  API_BAD_DELIVERY_PRE_CHECK,
  API_BAD_ORDERS_BY_CORE_ORDER
} from '../constants/API_ENDPOINTS';
import {request} from '../utils/request';

export const getLargeDeliveryInfoApi = (data) =>
  request(POST, API_BAD_DELIVERY_PRE_CHECK(), {data}, {silent: true});

export const createLargeDeliveryDriversApi = (data) =>
  request(POST, API_BAD_CREATE_ORDER(), {data}, {silent: true});

export const getBadOrdersByCoreOrderApi = (
  coreOrderId,
  locationId,
  orderType
) =>
  request(
    GET,
    API_BAD_ORDERS_BY_CORE_ORDER(coreOrderId, locationId, orderType),
    null,
    {silent: true}
  );
